export const SELECTED_CONVERSATIONS = ['selectedConversations'];
export const THREADLIST_MEMBER_MULTI_SELECT = ['threadListMembersBatchUpdates'];